<template>
	<aside class="bg-dish-red text-white leading-tight font-bold px-4 py-1 md:py-2">
		<div class="flex items-center justify-center">
			<p class="text-lg sm:text-2xl md:text-4xl lg:text-5xl">Pay As You Go HD TV <span class="inline-block">Starting At</span></p>
			<span class="ml-4 price text-5xl sm:ml-3 md:text-4xl lg:ml-4 lg:text-5xl">52</span>
			<div class="flex flex-col leading-none items-start">
				<span class="text-2xl md:text-lg lg:text-2xl">99</span>
				<span class="text-sm md:text-xs lg:text-sm">/mo.</span>
			</div>
		</div>
	</aside>
</template>

<style scoped>
	.price::before {
		content: '$';
		font-size: .5em;
		vertical-align: super;
	}
</style>
